var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6L9.20089 11.5289C9.13721 11.5907 9.08669 11.6642 9.05221 11.745C9.01774 11.8258 9 11.9125 9 12C9 12.0875 9.01774 12.1742 9.05221 12.255C9.08669 12.3358 9.13721 12.4093 9.20089 12.4711L15 18",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgChevronLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1IDZMOS4yMDA4OSAxMS41Mjg5QzkuMTM3MjEgMTEuNTkwNyA5LjA4NjY5IDExLjY2NDIgOS4wNTIyMSAxMS43NDVDOS4wMTc3NCAxMS44MjU4IDkgMTEuOTEyNSA5IDEyQzkgMTIuMDg3NSA5LjAxNzc0IDEyLjE3NDIgOS4wNTIyMSAxMi4yNTVDOS4wODY2OSAxMi4zMzU4IDkuMTM3MjEgMTIuNDA5MyA5LjIwMDg5IDEyLjQ3MTFMMTUgMTgiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNzE0MjkiIHZlY3Rvci1lZmZlY3Q9Im5vbi1zY2FsaW5nLXN0cm9rZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";